// Import components
import { Autocomplete } from './components/Autocomplete.js'
import { CustomDropdown } from './components/CustomDropdown.js'
import { TransactionTypeSwitch } from './components/TransactionTypeSwitch.js'
import { SearchFormHandler } from './components/SearchFormHandler.js'
import { ImageCarousel } from './components/Carousel.js'
import { Slideshow } from './components/Slideshow.js'
import { ComplexMapping } from './components/ComplexMapping.js'
import { Map } from './components/Maps.js'
import { initFixedHeader } from './components/Navigation'

// Initialize all components when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {



    initFixedHeader(".header-wrapper", "fixed-header");

    document.querySelectorAll('[data-slideshow]').forEach(element => {
        const images = JSON.parse(element.dataset.slideshow);

        new Slideshow(element, images);
    });


    window.initTooltips = function() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        return tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }

    window.addFullLoader = function(target) {
        removeLoader();
        target.insertAdjacentHTML('beforeend',
            '<div id="loader-anim" class="loader-wrapper">\n' +
            '  <div class="spinner-border text-light" role="status">\n' +
            '    <span class="visually-hidden">Loading...</span>\n' +
            '  </div>\n' +
            '</div>'
        );
    }

    window.addLoader = function(target) {
        removeLoader();
        target.insertAdjacentHTML('beforeend',
            '<div id="loader-anim" class="loader vertical-align-middle loader-ellipsis" data-type="default"></div>'
        );
    }

    window.removeLoader = function() {
        const loader = document.getElementById('loader-anim');
        if (loader) {
            loader.remove();
        }
    }

// Store the instances if needed
    window.tooltipInstances = initTooltips();


    const carouselElement = document.getElementById('image-gallery');

    if (carouselElement) {
        // Initialize the enhanced image carousel
        const mainCarousel = document.querySelector('#image-gallery');
        if (mainCarousel) {
            const imageGallery = new ImageCarousel('#image-gallery', {
                enableKeyboardNavigation: false,
                enableFullscreenMode: true,
                enableAutoplay: false,
                showPagination: false,
                enableThumbnails: true,
            });

            // Store instance for global access if needed
            window.imageGallery = imageGallery;
        }
    }


    // init Swiper:


    // Initialize transaction type switch
    const transactionElement = document.getElementById('transaction_id');


    // document.addEventListener('click', function(e) {
    //     console.log('clicked');
    //     console.log(e.target);
    //     if (e.target.classList.contains('btn-filtering')) {
    //         console.log('btn-filtering clicked to toggle');
    //         document.body.classList.toggle('filtering-open');
    //     }
    // });

    document.querySelectorAll('.btn-filtering').forEach(function(button) {
        button.addEventListener('click', function() {
            document.body.classList.add('filtering-open');
        });
    });

    const closeFilter = document.getElementById('close-filter');
    if (closeFilter){
        closeFilter.addEventListener('click', function() {
            document.body.classList.remove('filtering-open');
        });
    }



    document.querySelectorAll('.navbar-toggler').forEach(function(button) {
        button.addEventListener('click', function() {
            document.body.classList.toggle('navbar-open');
        });
    });


    const closeMenu = document.getElementById('close-menu');
    if (closeMenu){
        closeMenu.addEventListener('click', function() {
            document.body.classList.remove('navbar-open');
        });
    }



    new SearchFormHandler();

    if (transactionElement) {
        const transactionSwitch = new TransactionTypeSwitch(document.getElementById('transaction_id'));
    }


    // Initialize simple dropdown for category (using data-options attribute)
    const categoryInput = document.getElementById('categoryInput');
    if (categoryInput) {
        // Pass null for searchUrl since we're using simpleDropdown mode
        const categoryDropdown = new Autocomplete('categoryInput', 'categoryResults', null, false, 'category_id', false, false, true, true);

    }

    const partitioningInput = document.getElementById('partitioningInput');
    if (partitioningInput) {
        // Pass null for searchUrl since we're using simpleDropdown mode
        const partitioningInput = new Autocomplete('partitioningInput', 'partitioningResults', null, false, 'partitioning', true, false, false, true);

    }

    const funitureInput = document.getElementById('funitureInput');
    if (partitioningInput) {
        // Pass null for searchUrl since we're using simpleDropdown mode
        const funitureInput = new Autocomplete('funitureInput', 'furnitureResults', null, false, 'furniture', true, false, false, true);

    }

    // Initialize custom dropdowns
    const dropdowns = {};
    document.querySelectorAll('.custom-dropdown').forEach(container => {
        const dropdown = new CustomDropdown(container);
        const id = container.querySelector('.dropdown-toggle').id;
        dropdowns[id] = dropdown;
    });

    // Initialize alternative single select autocomplete (using multiselect code with forceSingleSelect)
    const altSearchInput = document.getElementById('altSearchInput');
    if (altSearchInput) {
        const useMockData = false;

        const altAutocomplete = new Autocomplete('altSearchInput', 'altAutocompleteResults', null, useMockData, 'altSelectedId');

        // Listen for selection events
        altSearchInput.addEventListener('autocomplete-select', (e) => {
          //  console.log('Alt item selected:', e.detail);
           // console.log('Alt hidden input value:', document.getElementById('altSelectedId').value);
        });
    }

    // Initialize alternative single select autocomplete (using multiselect code with forceSingleSelect)
    const altSearchInputMulti = document.getElementById('altSearchInputMulti');
    if (altSearchInputMulti) {
        const useMockData = false;

        const altAutocompleteMulti = new Autocomplete('altSearchInputMulti', 'altAutocompleteResults', null, useMockData, 'altSelectedId', true, true);


    }




    function initializeMap(el) {
        let lat = el.dataset.lat,
            lng = el.dataset.lng,
            zoom = el.dataset.zoom,
            exact = el.dataset.exact,
            radius = el.dataset.range,
            color = el.dataset.color
        ;

        new Map(el, lat, lng, zoom, exact, radius, color);
    }

    // Lazy load trigger
    document.addEventListener('lazybeforeunveil', function (e) {
        if (e.target.classList.contains('map')) {
            initializeMap(e.target);
        }
    });

    // Initialize maps that are not lazy loaded
    document.querySelectorAll('.map:not(.lazyload)').forEach(el => {
        initializeMap(el);
    });





    document.querySelectorAll('.swiper').forEach(el => {
        // Read parameters from data attributes
        const slidesPerView = parseInt(el.dataset.slidesPerView) || 1;
        const spaceBetween = parseInt(el.dataset.spaceBetween) || 0;

        const delay = parseInt(el.dataset.autoplay) || 0;
        const paginationEnabled = el.dataset.pagination === "true";
        const lazy = el.dataset.lazy === "true";
        const loop = el.dataset.loop === "true";
        const navigationEnabled = el.dataset.navigation === "true";
        const breakpoints = el.dataset.breakpoints ? JSON.parse(el.dataset.breakpoints) : {};



        // Prepare Swiper config
        const config = {
            slidesPerView,
            spaceBetween,
            breakpoints,
            delay,
            loop,
            lazy
        };

        if (delay){
            config.autoplay = {
                delay: delay
               // disableOnInteraction: false,
            };
        }

        if (paginationEnabled) {
            config.pagination = {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
            };
        }

        if (navigationEnabled) {
            //console.log('here');
            config.navigation = {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev')
            };
        }

        // Init Swiper
        new Swiper(el, config);
    });


    document.querySelectorAll('.text-container').forEach(container => {
        const textElement = container.querySelector('.text-content');
        const readMoreBtn = container.querySelector('.read-more-btn');

        readMoreBtn.addEventListener('click', function() {
            const isExpanded = textElement.classList.contains('expanded');
            const collapsedText = readMoreBtn.getAttribute('data-collapsed-text');
            const expandedText = readMoreBtn.getAttribute('data-expanded-text');

            if (!isExpanded) {
                textElement.classList.remove('truncated');
                textElement.classList.add('expanded');
                readMoreBtn.textContent = expandedText;
            } else {
                textElement.classList.remove('expanded');
                textElement.classList.add('truncated');
                readMoreBtn.textContent = collapsedText;
            }
        });
    });

    document.querySelectorAll('.div-container').forEach(container => {
        const textElement = container.querySelector('.div-content');
        const viewMoreBtn = container.querySelector('.view-more-btn');

        viewMoreBtn.addEventListener('click', function() {
            const isExpanded = textElement.classList.contains('expanded');
            const collapsedText = viewMoreBtn.getAttribute('data-collapsed-text');
            const expandedText = viewMoreBtn.getAttribute('data-expanded-text');

            if (!isExpanded) {
                textElement.classList.remove('truncated');
                textElement.classList.add('expanded');
                viewMoreBtn.textContent = expandedText;
            } else {
                textElement.classList.remove('expanded');
                textElement.classList.add('truncated');
                viewMoreBtn.textContent = collapsedText;
            }
        });
    });

//
//     function coverIframe(containerSelector, iframeSelector, videoRatio = 16 / 9) {
//         const container = document.querySelector(containerSelector);
//         const iframe = document.querySelector(iframeSelector);
//         if (!container || !iframe) return;
//
//         const containerWidth = container.offsetWidth;
//         const containerHeight = container.offsetHeight;
//         const containerRatio = containerWidth / containerHeight;
//
//         let iframeWidth, iframeHeight;
//
//         if (containerRatio > videoRatio) {
//             // Container is wider: match width, extend height (crop top/bottom)
//             iframeWidth = containerWidth;
//             iframeHeight = containerWidth / videoRatio;
//         } else {
//             // Container is taller: match height, extend width (crop sides)
//             iframeHeight = containerHeight;
//             iframeWidth = containerHeight * videoRatio;
//         }
//
//         iframe.style.width = `${iframeWidth}px`;
//         iframe.style.height = `${iframeHeight}px`;
//
//         // Center it
//         iframe.style.top = `${(containerHeight - iframeHeight) / 2}px`;
//         iframe.style.left = `${(containerWidth - iframeWidth) / 2}px`;
//     }
//
// // Initialize
//     function initCoverVideo() {
//         coverIframe('.video-container', '#bg-video');
//     }
//
//     window.addEventListener('load', initCoverVideo);
//     window.addEventListener('resize', initCoverVideo);

    // // Handle form submission
    // const submitBtn = document.getElementById('submitBtn');
    // if (submitBtn) {
    //     submitBtn.addEventListener('click', () => {
    //         const transactionType = transactionSwitch.getValue();
    //         const category = dropdowns['categoryDropdown']?.getValue();
    //         const selectedRooms = dropdowns['roomsDropdown']?.getValue();
    //         const locationIdElement = document.getElementById('selectedId');
    //         const searchInputElement = document.getElementById('searchInput');
    //         const locationId = locationIdElement ? locationIdElement.value : '';
    //         const locationText = searchInputElement ? searchInputElement.value : '';
    //
    //         const formData = {
    //             transactionType: transactionType,
    //             category: category,
    //             rooms: selectedRooms,
    //             locationId: locationId,
    //             locationText: locationText
    //         };
    //
    //         //console.log('Form Data:', formData);
    //
    //         // Validate
    //         if (!category) {
    //             alert('Please select a category');
    //             return;
    //         }
    //
    //         if (!selectedRooms || selectedRooms.length === 0) {
    //             alert('Please select at least one room option');
    //             return;
    //         }
    //
    //         if (!locationId) {
    //             alert('Please select a location from the search');
    //             return;
    //         }
    //
    //         // Here you would normally submit to your server
    //         alert(`Submitted!\nTransaction: ${transactionType === '1' ? 'Închiriere' : 'Vânzare'}\nCategory: ${category}\nRooms: ${selectedRooms.join(', ')}\nLocation: ${locationText} (ID: ${locationId})`);
    //     });
    // }

    new ComplexMapping();


    AOS.init();

    /*AJAX SEND*/

    window.initAjxSend = function() {
        var t = (new Date()).getTime();

        // Get all forms with class 'ajxsend'
        var ajxsendForms = document.querySelectorAll('.ajxsend');

        ajxsendForms.forEach(function(form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();
                var target = this;
                var fields = target.querySelectorAll('.required');
                var afterpost = target.querySelector('.afterpost');
                var prepost = target.querySelector('.prepost');
                var ok = 1;

                // Check required fields
                fields.forEach(function(field) {
                    if (field.value === '') {
                        ok = 0;
                        field.parentNode.classList.add('has-error');
                    }
                });

                // Check required consent checkboxes
                var fieldsConsent = target.querySelectorAll('.required-consent');
                fieldsConsent.forEach(function(field) {
                    if (!field.checked) {
                        ok = 0;
                        field.parentNode.classList.add('has-error');
                    }
                });

                if (!ok) return;

                var td = (new Date()).getTime() - t;

                window.addFullLoader(target);

                // Serialize form data
                var formData = new FormData(target);
                formData.append('td', td);

                // Make POST request
                fetch(target.getAttribute('action'), {
                    method: 'POST',
                    body: formData
                })
                    .then(function(response) {
                        return response.json();
                    })
                    .then(function(data) {
                        console.log('here1');
                        window.removeLoader();

                        if (data.html !== undefined) {
                            target.innerHTML = data.html;
                        }

                        if (afterpost) {
                            console.log('here2');
                            if (prepost) {
                                prepost.classList.add('hidden');
                            }
                            afterpost.classList.remove('hidden');
                        }
                    })
                    .catch(function(error) {
                        console.error('Error:', error);
                        window.removeLoader();
                    });
            });
        });
    };

    window.initAjxSend();
});